(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/shared/assets/javascripts/api.js') >= 0) return;  svs.modules.push('/components/content/shared/assets/javascripts/api.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const FEATURE_TOGGLE_CMS_API_CLIENT = 'ft-use-cms-api-client';
const FEATURE_TOGGLE_PARTNER_CMS_API = 'ft-use-partner-cms-api';
const useLegacyJupiterApi = !svs.core.detect.feature(FEATURE_TOGGLE_CMS_API_CLIENT, true);
const useLegacyPartnerApi = !svs.core.detect.feature(FEATURE_TOGGLE_PARTNER_CMS_API, true);
function hasValue(value) {
  return !(typeof value === 'undefined' || value === null || value === '');
}
function normalizeQueryValue(value) {
  if (Array.isArray(value)) {
    const filtered = value.filter(hasValue);
    return filtered.length ? filtered : undefined;
  }
  return hasValue(value) ? value : undefined;
}
function normalizeCsvValue(value) {
  if (Array.isArray(value)) {
    const filtered = value.filter(hasValue);
    return filtered.length ? filtered.join(',') : undefined;
  }
  if (!hasValue(value)) {
    return undefined;
  }
  return String(value);
}
function normalizeSortParam(sortValue) {
  if (Array.isArray(sortValue)) {
    return normalizeQueryValue(sortValue);
  }
  if (typeof sortValue === 'string' && sortValue) {
    const _sortValue$split = sortValue.split(':'),
      _sortValue$split2 = _slicedToArray(_sortValue$split, 2),
      field = _sortValue$split2[0],
      direction = _sortValue$split2[1];
    return field ? ["".concat(field, ";").concat(direction || 'desc')] : undefined;
  }
  return undefined;
}

function responseFilter(resp, withLegacyFilter) {
  const _svs$content$shared$f = svs.content.shared.filters.gameAnalysisFilter,
    gameAnalysisFilter = _svs$content$shared$f.gameAnalysisFilter,
    gameAnalysisFilterLegacy = _svs$content$shared$f.gameAnalysisFilterLegacy,
    shouldRunGameAnalysisFilter = _svs$content$shared$f.shouldRunGameAnalysisFilter;
  if (shouldRunGameAnalysisFilter(resp)) {
    if (withLegacyFilter === undefined || withLegacyFilter) {
      return gameAnalysisFilterLegacy(resp);
    }
    return gameAnalysisFilter(resp);
  }
  return resp;
}

function basicFilter(filter, callback) {
  const apiUtils = svs.content.shared;
  const validationError = apiUtils.validateOptions(filter, ['type']);
  if (validationError) {
    if (callback && typeof callback === 'function') {
      callback(validationError);
      return;
    }
    return $.Deferred().reject(validationError);
  }

  const useLegacy = useLegacyJupiterApi || filter.routesDomain === 'partner' && useLegacyPartnerApi;
  if (useLegacy) {
    const params = {
      channel: svs.core.data.capabilities.channel,
      contentType: filter.type,
      count: filter.count || 1,
      domainCategories: filter.domainCategories,
      include: filter.include,
      matchAllDomainCategories: filter.matchAllDomainCategories,
      modifiedSince: filter.modifiedSince,
      offset: filter.offset || 0,
      orderBy: filter.orderBy,
      parentId: filter.parentId,
      sortOrder: filter.sortOrder
    };
    apiUtils.appendUserParams(params);
    let cbk;
    if (callback) {
      cbk = (err, resp) => {
        callback(err, responseFilter(resp, filter.withLegacyFilter));
      };
      return apiUtils.callJupiter(new apiUtils.ContentUrlBuilder('basicfilter', filter.routesDomain).addParams(params).build(), cbk);
    }
    return apiUtils.callJupiter(new apiUtils.ContentUrlBuilder('basicfilter', filter.routesDomain).addParams(params).build())
    .then(resp => $.Deferred().resolve(responseFilter(resp, filter.withLegacyFilter)))
    .catch(err => $.Deferred().reject(err));
  }

  const client = apiUtils.getCmsClient({
    routesDomain: filter.routesDomain
  });

  let domainCategoryQuery;
  if (filter.domainCategories && filter.domainCategories.length > 0) {
    const operator = filter.matchAllDomainCategories ? ' AND ' : ' OR ';
    domainCategoryQuery = filter.domainCategories.map(cat => {
      const _cat$split = cat.split('/'),
        _cat$split2 = _slicedToArray(_cat$split, 2),
        category = _cat$split2[0],
        value = _cat$split2[1];
      return "".concat(category, "=").concat(value);
    }).join(operator);
  }

  const sort = normalizeSortParam(filter.orderBy ? "".concat(filter.orderBy, ":").concat(filter.sortOrder || 'desc') : undefined);
  return client.v1.content.filter({
    channels: normalizeCsvValue(svs.core.data.capabilities.channel),
    contentTypes: normalizeCsvValue(filter.type),
    count: filter.count || 1,
    domainCategoryQuery,
    include: filter.include,
    modifiedSince: filter.modifiedSince,
    offset: filter.offset || 0,
    parentIds: normalizeCsvValue(filter.parentId),
    sort
  }).then(result => {
    const filtered = responseFilter(result, filter.withLegacyFilter);
    if (callback && typeof callback === 'function') {
      callback(null, filtered);
      return;
    }
    return filtered;
  }).catch(err => {
    if (callback && typeof callback === 'function') {
      callback(err);
      return;
    }
    throw err;
  });
}

function getGameAnalyses(filter, callback) {
  const domainCategories = [];
  if (filter.id) {
    if (filter.idType === 'match') {
      domainCategories.push("svs-domain-sport-events/".concat(filter.id));
    } else if (filter.idType === 'race') {
      domainCategories.push("svs-domain-sport-events-racing/".concat(filter.id));
    } else {
      if (callback && typeof callback === 'function') {
        callback("unsupported idType: ".concat(filter.idType));
        return;
      }
      return $.Deferred().reject("unsupported idType: \"".concat(filter.idType, "\""));
    }
  }
  if (filter.product) {
    domainCategories.push("svs-domain-products/".concat(filter.product));
  }
  if (filter.raceProduct) {
    domainCategories.push("svs-domain-products-racing/".concat(filter.raceProduct));
  }
  if (filter.participantId) {
    domainCategories.push("svs-domain-sport-participants/".concat(filter.participantId));
  }
  const params = {
    count: filter.count,
    domainCategories,
    include: filter.include,
    matchAllDomainCategories: typeof filter.matchAll !== 'undefined' ? filter.matchAll : true,
    offset: filter.offset,
    orderBy: 'authorProfile.rank',
    sortOrder: 'desc',
    routesDomain: 'partner',
    type: 'cnt:gameAnalysis',
    withLegacyFilter: typeof filter.withLegacyFilter === 'boolean' ? filter.withLegacyFilter : true
  };
  return basicFilter(params, callback);
}

function getDrawAnalyses(filter, callback) {
  const domainCategories = [];
  if (filter.id) {
    const domain = filter.idType === 'race' ? 'svs-domain-sport-events-racing' : 'svs-domain-sport-draws';
    if (Array.isArray(filter.id)) {
      for (let i = 0; i < filter.id.length; ++i) {
        domainCategories.push("".concat(domain, "/").concat(filter.id[i]));
      }
    } else {
      domainCategories.push("".concat(domain, "/").concat(filter.id));
    }
  }
  if (filter.product) {
    domainCategories.push("svs-domain-products/".concat(filter.product));
  }
  if (filter.raceProduct) {
    domainCategories.push("svs-domain-products-racing/".concat(filter.raceProduct));
  }
  const params = {
    count: filter.count,
    domainCategories,
    include: filter.include,
    matchAllDomainCategories: typeof filter.matchAll !== 'undefined' ? filter.matchAll : true,
    offset: filter.offset,
    orderBy: 'authorProfile.rank',
    sortOrder: 'desc',
    routesDomain: 'partner',
    type: 'cnt:drawAnalysis',
    withLegacyFilter: typeof filter.withLegacyFilter === 'boolean' ? filter.withLegacyFilter : true
  };
  return basicFilter(params, callback);
}

function getAuthorProfiles(filter, callback) {
  filter = filter || {};
  const domainCategories = [];
  if (filter.product) {
    domainCategories.push("svs-domain-products/".concat(filter.product));
  }
  const params = {
    count: filter.count || 20,
    domainCategories,
    include: filter.include,
    matchAllDomainCategories: true,
    offset: filter.offset,
    orderBy: 'authorProfile.rank',
    sortOrder: 'desc',
    routesDomain: 'partner',
    type: 'cnt:authorProfile'
  };
  return basicFilter(params, callback);
}

function getContentById(options, callback) {
  const apiUtils = svs.content.shared;
  const validationError = apiUtils.validateOptions(options, ['id']);
  const contentApiVersion = svs.core.config.data.svsconfig.contentApiVersion;
  const routesDomain = svs.core.config.data.svsconfig.routesDomain;
  if (validationError) {
    callback(validationError);
    return;
  }

  if (useLegacyJupiterApi) {
    apiUtils.callJupiter(new apiUtils.ContentUrlBuilder("/content/".concat(contentApiVersion, "/id/").concat(options.id), routesDomain).build(), callback);
    return;
  }

  const client = apiUtils.getCmsClient();
  return client.v1.content.getById(options.id, {
    include: normalizeQueryValue(options.include)
  }).then(result => {
    if (callback && typeof callback === 'function') {
      callback(null, result);
      return;
    }
    return result;
  }).catch(err => {
    if (callback && typeof callback === 'function') {
      callback(err);
      return;
    }
    throw err;
  });
}
svs.content.shared.cms = {
  basicFilter,
  getAuthorProfiles,
  getContentById,
  getDrawAnalyses,
  getGameAnalyses
};

 })(window);